import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

// Releases are scheduled in Eastern Time, matching how video releases are scheduled.
export const RELEASE_TZ = 'America/New_York';

/**
 * react-datepicker works in the browser's local time. We treat the wall-clock value the
 * admin picked as Eastern Time, regardless of where the admin is, and convert it to UTC.
 */
export const pickerDateToUtcIso = date => dayjs.tz(dayjs(date).format('YYYY-MM-DDTHH:mm:00'), RELEASE_TZ).toISOString();

/** Inverse of pickerDateToUtcIso: a local Date whose wall clock shows the ET time. */
export const utcToPickerDate = iso => dayjs(dayjs(iso).tz(RELEASE_TZ).format('YYYY-MM-DDTHH:mm:ss')).toDate();

/** Tomorrow at 00:00 ET, as a picker Date. */
export const defaultScheduledPickerDate = () =>
	dayjs(dayjs().tz(RELEASE_TZ).add(1, 'day').format('YYYY-MM-DDT00:00:00')).toDate();

export const formatReleaseET = iso => `${dayjs(iso).tz(RELEASE_TZ).format('MMM D, YYYY h:mm A')} ET`;

export const isReleased = iso => !iso || new Date(iso).getTime() <= Date.now();

export const formatDuration = seconds => {
	const s = Math.max(0, Math.round(Number(seconds) || 0));
	const h = Math.floor(s / 3600);
	const m = Math.floor((s % 3600) / 60);
	const sec = String(s % 60).padStart(2, '0');
	return h ? `${h}:${String(m).padStart(2, '0')}:${sec}` : `${m}:${sec}`;
};
